<template>
<div>
  <!-- <pre v-text="items" class="caption grey lighten-4 pa-3" /> -->
  <slot name="before" ></slot>
  <v-chip small
    v-for="item in items"
    @click="$emit('selected', item)"
    :key="item.id" >
    {{item.title}}
    <span v-if="withSpaceName" >@{{item.space_name}}</span>
  </v-chip>
  <slot name="after" ></slot>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ProductChips',
  props: {
    productIds: { type: Array, required: false },
    products: { type: Array, required: false },
    withSpaceName: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters(['getProductById']),
    items () {
      if (this.products) { return this.products }
      if (this.productIds) {
        return this.productIds.map((p) => { return this.getProductById(p) })
      }
      return []
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProductChips.vue?629ffe28